import { CardBaseComponent } from '@/components/base/card-base/card-base.component';
import { BookletBuildingStageTranslatePipe } from '@/extensions/booklet--building-stage-translate.pipe';
import { BuildingDocTypeTranslatePipe } from '@/extensions/booklet-building-type-translate.pipe';
import { PropertyBookletBuildingType } from '@/views/property/property-booklet/property-booklet.component';
import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PropertyBookletBuildingDocument, PropertyBookletBuildingDocumentType, PropertyBookletBuildingStage, RealProperty } from '@eemo/api-client';
import { PropertyBookletBuildingDialogComponent, PropertyBookletBuildingDialogData } from '../property-booklet-building-dialog/property-booklet-building-dialog.component';
import { PropertyBookletBuildingService } from './property-booklet-building.service';

interface RequiredDoc {
  type: PropertyBookletBuildingDocumentType,
  stage: PropertyBookletBuildingStage;
  isSent: boolean
}

@Component({
  selector: 'app-property-booklet-building-card',
  standalone: true,
  imports: [CardBaseComponent, NgTemplateOutlet, MatButtonModule,
    MatIconModule, BuildingDocTypeTranslatePipe, BookletBuildingStageTranslatePipe, MatTooltipModule],
  templateUrl: './property-booklet-building-card.component.html',
  styleUrl: './property-booklet-building-card.component.scss',
  providers: [PropertyBookletBuildingService]
})
export class PropertyBookletBuildingCardComponent implements OnChanges {
  private dialog = inject(MatDialog);
  private readonly propertyBookletBuildingService = inject(PropertyBookletBuildingService);

  @Input({required: true}) buildingComponent: PropertyBookletBuildingType;
  @Input({required: true}) bookletUid: string;
  @Input({required: true}) prop: RealProperty;
  @Input({required: true}) bookletInfo: PropertyBookletBuildingDocument[];
  @Output() updated = new EventEmitter<void>();

  title: string;
  summary: string;
  PropertyBookletBuildingType = PropertyBookletBuildingType;
  requiredDocs: RequiredDoc[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['buildingComponent']) {
      this.setTitle();
      this.setSummary();
    }
    if (changes['bookletInfo']?.currentValue) {
      this.setFiles();
    }
  }

  edit() {
    if (this.dialog.openDialogs.length === 0) {
      const data: PropertyBookletBuildingDialogData = {
        componentType: this.buildingComponent,
        bookletUid: this.bookletUid,
        prop: this.prop
      }
      const dialogRef = this.dialog.open(PropertyBookletBuildingDialogComponent, {
        data
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.updated.emit();
        }
      });
    }
  }

  setTitle() {
    this.title = PropertyBookletBuildingService.getTitle(this.buildingComponent);
  }

  setSummary() {
    this.summary = PropertyBookletBuildingService.getSummary(this.buildingComponent);
  }

  setFiles() {
    const requiredDocs = [];
    this.propertyBookletBuildingService.requiredDocByType.get(this.buildingComponent).forEach(docType => {
      requiredDocs.push({
        type: docType,
        stage: PropertyBookletBuildingStage.DESIGN,
        isSent: !!this.bookletInfo.find(info => info.stage === PropertyBookletBuildingStage.DESIGN && info.type === docType && info.document),
      });
      requiredDocs.push({
        type: docType,
        stage: PropertyBookletBuildingStage.EXECUTION,
        isSent: !!this.bookletInfo.find(info => info.stage === PropertyBookletBuildingStage.EXECUTION && info.type === docType && info.document),
      });
    });

    this.requiredDocs = requiredDocs
  }
}
